jQuery.validator.addMethod("phoneAU", function(phone_number, element) {
	return this.optional(element) 
		|| phone_number.match(/^(((\+61)[ -]?((\(0[2|3|4|7|8]{1}\))|([2|3|4|7|8]{1})))|(\()?0[2|3|4|7|8]{1}(\))?)[ -]?((\d{8})|(\d{4}[ -]?\d{4})|([ -]?\d{2}[ -]?\d{3}[ -]?\d{3}))$/)
		|| phone_number.match(/(^(1300|1800|1900|1902)[ -]?(\d{6}|\d{3}[ -]?\d{3}|\d{2}[ -]?\d{2}[ -]?\d{2})$)|(^13[ -]?(\d{4}|\d{1}[ -]?\d{3}|\d{2}[ -]?\d{2})$)/);
}, "Please enter a valid phone number including the area code, e.g. 02 9999 9999.");

jQuery.validator.addMethod("dateAU", function(value, element) {
	var check = false;
	var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
	if( re.test(value)) {
		var adata = value.split('/');
		var gg = parseInt(adata[0],10);
		var mm = parseInt(adata[1],10);
		var aaaa = parseInt(adata[2],10);
		var xdata = new Date(aaaa,mm-1,gg, 0, 0, 0);
		if ( ( xdata.getFullYear() === aaaa ) && ( xdata.getMonth() === mm - 1 ) && ( xdata.getDate() === gg ) ){
			check = true;
		} else {
			check = false;
		}
	} else {
		check = false;
	}
	return this.optional(element) || check;
}, "Please enter a valid date, e.g. 26/05/2018");

jQuery.validator.addMethod("postcodeAU", function(value, element) {
	return this.optional(element) || /^(0[289][0-9]{2})$|^([1-9][0-9]{3})$/.test(value);
}, "Please enter a valid Australian postal code");
